import { Suspense, lazy, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SWRConfig } from "swr";
import { getFaviconPath, getSiteTitle } from "./helpers/siteConfig";

// home pages
const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));
const HomeFashion4 = lazy(() => import("./pages/home/HomeFashionFour"));

// shop pages

const ShopGridRightSidebar = lazy(() =>
  import("./pages/shop/ShopGridRightSidebar")
);

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));

const ProductSlider = lazy(() => import("./pages/shop-product/ProductSlider"));

// blog pages
const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
const BlogDetailsStandard = lazy(() =>
  import("./pages/blog/BlogDetailsStandard")
);

// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const Support = lazy(() => import("./pages/other/Support"));
const Warranty = lazy(() => import("./pages/other/Warranty"));
const ReturnPolicy = lazy(() => import("./pages/other/ReturnPolicy"));
const OrganizationalSales = lazy(() =>
  import("./pages/other/OrganizationalSales")
);
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const SendOtp = lazy(() => import("./pages/other/SendOtp"));
const VerifyOtp = lazy(() => import("./pages/other/VerifyOtp"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Checkout = lazy(() => import("./pages/other/Checkout"));
const PaymentReturn = lazy(() => import("./pages/other/PaymentReturn"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  useEffect(() => {
    const link = document.querySelector('link[rel="icon"]');
    if (link) {
      link.href = (process.env.PUBLIC_URL || "") + getFaviconPath();
    }
    document.title = getSiteTitle();
  }, []);

  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="flone-preloader-wrapper">
              <div className="flone-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <SWRConfig
            value={{
              refreshInterval: 10000,
              revalidateOnFocus: true,
              revalidateOnReconnect: true,
              revalidateOnMount: true,
              revalidateIfStale: true,
              dedupingInterval: Infinity,
            }}
          >
            <Routes>
              {/* <Route
                path={process.env.PUBLIC_URL + "/"}
                element={<HomeFashion />}
              /> */}
              <Route
                path={process.env.PUBLIC_URL + "/"}
                element={<HomeFashion4 />}
              />

              <Route
                path={process.env.PUBLIC_URL + "/products"}
                element={<ShopGridRightSidebar />}
              />

              {/* Shop product pages */}
              <Route
                path={process.env.PUBLIC_URL + "/product/:id"}
                element={<Product />}
              />

              <Route
                path={process.env.PUBLIC_URL + "/product-slider/:id"}
                element={<ProductSlider />}
              />

              {/* Blog pages */}

              <Route
                path={process.env.PUBLIC_URL + "/blogs"}
                element={<BlogRightSidebar />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/blog/:id"}
                element={<BlogDetailsStandard />}
              />

              {/* Other pages */}
              <Route
                path={process.env.PUBLIC_URL + "/about"}
                element={<About />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/contact"}
                element={<Contact />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/support"}
                element={<Support />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/warranty"}
                element={<Warranty />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/return-policy"}
                element={<ReturnPolicy />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/organizational-sales"}
                element={<OrganizationalSales />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/my-account"}
                element={<MyAccount />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/login"}
                element={<SendOtp />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/verify-otp"}
                element={<VerifyOtp />}
              />

              <Route
                path={process.env.PUBLIC_URL + "/cart"}
                element={<Cart />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/wishlist"}
                element={<Wishlist />}
              />

              <Route
                path={process.env.PUBLIC_URL + "/checkout"}
                element={<Checkout />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/paymentResult/:orderCode"}
                element={<PaymentReturn />}
              />

              <Route path="*" element={<NotFound />} />
              <Route path="404" element={<NotFound />} />
            </Routes>
          </SWRConfig>
        </Suspense>
      </ScrollToTop>
    </Router>
    </HelmetProvider>
  );
};

export default App;
